import { FC, ReactNode } from 'react';

import { CellPrice, CellTerm, DiscountPrice } from '../entries/entries.styles';
import { Price } from '../model';

type Props = {
    term: ReactNode;
    price: Price | undefined;
    isMonthly?: boolean;
    isDiscount?: boolean;
    dataTest?: string;
};

export const PriceRow: FC<Props> = ({ term, price, isMonthly, isDiscount, dataTest }) => {
    if (!price?.formattedValue || price?.value === undefined) {
        return null;
    }

    if (isDiscount) {
        return (
            <>
                <CellTerm>{term}</CellTerm>
                <DiscountPrice price={price} isMonthly={isMonthly} dataTest={dataTest} />
            </>
        );
    }

    return (
        <>
            <CellTerm>{term}</CellTerm>
            <CellPrice price={price} isMonthly={isMonthly} dataTest={dataTest} />
        </>
    );
};
